import { useReducer } from 'react'
import { useRouter } from 'next/router'

const useFormHook = ({ packages, isRenewingMembership }) => {
  const router = useRouter()

  const initialState = {
    activePackages: packages.filter(item => item.status === 1),
    currentStep: 'membershipSelection',
    isLegalAge: isRenewingMembership,
    isRequestingCard: false,
    isSubscribingPromotions: false,
    selectedPackage: null,
    errors: [],
  }

  const submitMembershipForm = formState => {
    const chosenPackage = formState.activePackages.find(
      item => item.id === formState.selectedPackage
    )
    router.push({
      pathname: '/loyalty/memberships/pay',
      query: {
        orderType: 'membership',
        programmeId: 1,
        id: chosenPackage.id,
        card: formState.isRequestingCard,
        receivePromo: formState.isSubscribingPromotions,
      },
    })
  }

  const reducer = (formState, action) => {
    switch (action.type) {
      case 'SET_PACKAGE_OPTION':
        return {
          ...formState,
          selectedPackage: action.id,
        }
      case 'TOGGLE_LEGAL_AGE':
        return {
          ...formState,
          isLegalAge: !formState.isLegalAge,
        }
      case 'TOGGLE_PROMOTION_SUBSCRIPTION':
        return {
          ...formState,
          isSubscribingPromotions: !formState.isSubscribingPromotions,
        }
      case 'PRESSED_CONTINUE': {
        const validateFields = ['isLegalAge', 'selectedPackage'].reduce(
          (acc, currentValue) => {
            if (!formState[currentValue]) {
              return [...acc, currentValue]
            }

            return acc
          },
          []
        )

        return {
          ...formState,
          errors: validateFields,
          currentStep:
            validateFields.length > 0 ? formState.currentStep : 'cardSelection',
        }
      }
      case 'SUBMIT_MEMBERSHIP_FORM': {
        const validateFields = ['isLegalAge', 'selectedPackage'].reduce(
          (acc, currentValue) => {
            if (!formState[currentValue]) {
              return [...acc, currentValue]
            }

            return acc
          },
          []
        )

        if (validateFields.length > 0) {
          return {
            ...formState,
            errors: validateFields,
            currentStep: formState.currentStep,
          }
        } else {
          submitMembershipForm(formState)
        }

        return formState
      }
      default:
        return formState
    }
  }

  const [current, send] = useReducer(reducer, initialState)

  return [current, send]
}

export default useFormHook
